<template>
  <div class="modal-window bds071">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.OpinionBoardFile.001","보드 내 파일 추가") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :must-sort="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :single-select="singleSelect"
        show-select
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :server-items-length="totalFileCount"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents">

        <template v-slot:[`item.fileName`]="{ item }">
          <div class="txt large"
            :class="
              item.fileExtDesc === 'ppt' ? 'ico-file-ppt' :
              item.fileExtDesc === 'word' ? 'ico-file-word' :
              item.fileExtDesc === 'excel' ? 'ico-file-xlsx' :
              item.fileExtDesc === 'pdf' ? 'ico-file-pdf' :
              item.fileExtDesc === 'jpg' ? 'ico-file-jpg' :
              item.fileExtDesc === 'gif' ? 'ico-file-gif' :
              item.fileExtDesc === 'png' ? 'ico-file-png' :
              item.fileExt === 'tif' ? 'ico-file-tif' :
              item.fileExt === 'tiff' ? 'ico-file-tiff' :
              item.fileExt === 'bmp' ? 'ico-file-bmp' :
              item.fileExt === 'zip' ? 'ico-file-zip' :
              item.fileExt === 'hwp' ? 'ico-file-hwp' :
              'ico-file-etc'
            "
          >
            <button type="button" class="ell-singleline" @click="openFileViewer(item)">{{ item.fileName }}</button>
          </div>
        </template>

        <template v-slot:[`item.lastModDate`]="{ item }">
          <div v-if="isToday(item.lastModDate)">
            <momentAgo prefix="" suffix="전" :date="item.lastModDate" lang="kr"></momentAgo>
          </div>
          <div v-if="!isToday(item.lastModDate)">
            {{ $moment(item.lastModDate).format('YYYY.MM.DD') }}
          </div>
        </template>

        <template v-slot:[`item.lastModUserName`]="{ item }">
          <div class="droplayer member relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="name">{{ item.lastModUserName }}</v-btn>
              </template>
              <div class="dropdown-list">
                <UserTooltip
                  :userId="item.lastModUserId"
                />
              </div>
            </v-menu>
          </div>
        </template>

        <template slot="no-data">
          <div class="nodata-txt-noicon file">
            <v-alert :value="true">
              {{ $i18nUtil.trans("search.026","등록된 첨부파일이 없습니다.") }}
            </v-alert>
          </div>
        </template>
      </v-data-table>

      <div class="pagination" v-show="items.length > 0">
        <v-pagination
            v-model="page"
            circle
            :length="pageCount"
            :total-visible="7"
        ></v-pagination>
      </div>
      
      <footer class="modal-footer" v-show="items.length > 0">
        <button @click="copyBlock()" type="button" class="btn_ty1">{{ $i18nUtil.trans("button.register","등록") }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import EventBus from "@/js/eventbus/eventBus";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    UserTooltip
  },
  data() {
    return {
      singleSelect: false,
      totalFileCount: 0,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.file.filter.fileName","파일명"), value: 'fileName', sortable: true, },
        { text: this.$i18nUtil.trans("entity.file.filter.update","업데이트"), value: 'lastModDate', align: 'center', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdUserName","생성/수정자"), value: 'lastModUserName', align: 'center', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
      ],
      items: [],
      //checked: []
      /* 페이징 관련 */
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      /* 정렬 관련 */
      sortBy: 'lastModDate',
      sortDesc: true,
      changeTableData: false,
      /* 토스트 알림 */
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    page: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    sortBy: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    sortDesc: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true) {
          setTimeout(() => {
            obj.changeTableData = false;
            obj.selected = [];
            obj.getList();
          }, 500);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    getList() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/paper/blockFileList",
        method: "post",
        req: {
          groupId: obj.modalInfo.item.groupId,
          paperId: obj.modalInfo.item.paperId,
          page: obj.page - 1,
          itemsPerPage: obj.itemsPerPage,
          sortBy: obj.sortBy,
          sortDesc: obj.sortDesc
        }
      };

      obj
        .COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.totalFileCount = res.result.totalFileCount;
            obj.pageCount = res.result.totalPageCount;
            obj.items = res.result.fileList;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    copyBlock() {
      let obj = this;
      let returnResult = null;
      let chkval = [];
      for (let index = 0; index < this.selected.length; index++) {
        chkval.push(this.selected[index]);
      }
      if(chkval.length > 0) {
        let param = {
          chkval: chkval,
          deciId: this.modalInfo.item.deciId
        };
        EventBus.$emit("copyBlockFile", param);
        this.$emit("close");
      } else {
        // AlertModal - 파일을 선택해 주세요.
        obj.showAlertDialog(obj.$i18nUtil.trans("AB061"), null, { width: "400px" });
        return;
      }
    },
    copyBlockToOutput() {
      let obj = this;
      let returnResult = null;
      let chkval = [];
      for (let index = 0; index < this.selected.length; index++) {
        chkval.push("" + this.selected[index].id);
      }
      let reqData = {
        url: "/api/cofile/paper/copyBlockToDecision",
        method: "post",
        reqMap: {
          groupId: this.modalInfo.item.groupId,
          paperId: this.modalInfo.item.paperId,
          fileIds: chkval
        }
      };
      this.$axios
        .post(reqData.url, reqData.reqMap)
        .then(res => {
          let errorCode = res.data.errorCode;
          if (errorCode == null) {
            returnResult = res.data.result.result;
            this.copaperInsert(0, returnResult);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    copaperInsert(index, returnResult) {
      let max = returnResult.length;
      if (returnResult[index] == null) {
        if (index + 1 < max) {
          this.copaperInsert(index + 1, returnResult);
        } else {
          EventBus.$emit("outputBoardInsert", "outputBoardInsert");
          this.$emit("close");
        }
      }

      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/copyBlockToOpinion",
        method: "post",
        params: {
          groupId: returnResult[index].groupId,
          fileId: returnResult[index].fileId,
          fileExt: returnResult[index].fileExt,
          fileName: returnResult[index].fileName,
          locationId: returnResult[index].locationId,
          tenantId: returnResult[index].tenantId,
          groupId: returnResult[index].groupId,
          deciId: this.modalInfo.item.deciId
        }
      };
      this.$axios.post(reqData.url, returnResult[index]).then(response => {
        if (index + 1 < max) {
          this.copaperInsert(index + 1, returnResult);
        } else {
          EventBus.$emit("outputBoardInsert", "outputBoardInsert");
          this.$emit("close");
        }
      });
    },
    isToday(date) {
      let obj = this;
			let now = obj.$moment();
			let before24hours = obj.$moment().subtract(1, 'days');
			let lastUpdatedTime = obj.$moment(date);
			
			if(lastUpdatedTime.isBetween(before24hours, now)) {
				// 24시간 이내
				return true;
			} else {
				// 24시간 이후
				return false;
      }
    },
    /* 파일 뷰어 */
    openFileViewer(file) {
      let hanwha = $(location).attr("origin");
      window.open(hanwha + "/general/viewer/" + file.groupId + "/" + file.id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/board/opinion/OpinionBoardFile.vue